import { PROYECT, api_get, api_post, api_put } from "services/api";

import {
  startRequest,
  stopRequest,
  setSnackbar
} from "redux/actions/search/searchActions";

import { COLLECT_PERIODS_TYPES } from "redux/reducers/buildings/collectPeriods/collectPeriodsTypes";
import { addLabelArray } from "helpers/addLabelArray";

const {
  SET_COLLECT_PERIODS,
  NEW_COLLECT_PERIOD,
  SET_NEW_COLLECT_PERIOD,
  EDIT_COLLECT_PERIOD,
  SET_EDITED_COLLECT_PERIOD,
  CLEAR_COLLECT_PERIODS,
  HANDLE_COLLECT_PERIODS_INPUTS,
} = COLLECT_PERIODS_TYPES;

const urlCollectPeriods = `${process.env.REACT_APP_URL}${PROYECT}/buildings/collect_periods`;
const urlConfig = `${process.env.REACT_APP_URL}${PROYECT}/buildings/configurations`;

export function newCollectPeriod() {
  return {
    type: NEW_COLLECT_PERIOD
  };
}
export function clearCollectPeriods() {
  return {
    type: CLEAR_COLLECT_PERIODS
  };
}

export function editCollectPeriod(id) {
  return {
    type: EDIT_COLLECT_PERIOD,
    payload: id
  };
}

export const handleCollectPeriodsInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_COLLECT_PERIODS_INPUTS, payload: { key, value } });
};

export const fetchCollectPeriods = (idStation = null) => async dispatch => {
  dispatch(startRequest("fetchCollectPeriods"));

  try {
    const [collectPeriods, config] = await Promise.all([
      api_get(`${urlCollectPeriods}?stations=${idStation}`),
      api_get(urlConfig)
    ]);

    dispatch({
      type: SET_COLLECT_PERIODS,
      payload: {
        collectPeriods,
        types: addLabelArray(config.collectPeriodTypes)
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchCollectPeriods"));
};

export const fetchNewCollectPeriod = body => async dispatch => {
  dispatch(startRequest("fetchNewCollectPeriod"));
  try {
    const response = await api_post(urlCollectPeriods, body);

    const newCollectPeriod = Array.isArray(response) ? response[0] : response;

    dispatch({
      type: SET_NEW_COLLECT_PERIOD,
      payload: newCollectPeriod
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchNewCollectPeriod"));
};

export const fetchEditCollectPeriod = (body, id) => async dispatch => {
  dispatch(startRequest("fetchEditCollectPeriod"));
  try {
    const response = await api_put(`${urlCollectPeriods}/${id}`, body);

    const editedCollectPeriod = Array.isArray(response)
      ? response[0]
      : response;

    dispatch({
      type: SET_EDITED_COLLECT_PERIOD,
      payload: editedCollectPeriod
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchEditCollectPeriod"));
};
